import { empresaService } from '@/services/empresaService';

const getDefaultState = () => {
  return {
    empresas: [],
    empresa: null,
    isModified: false
  }
}

const state = getDefaultState();

const getters = {
  empresas: state => state.empresas,
  empresa: state => state.empresa,
  isEmpresasModified: state => !!state.isModified
};

const actions = {
  async fetchEmpresas({ commit }) {
    try {
      const response = await empresaService.getEmpresas();
      commit('SET_EMPRESAS', response);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchEmpresaAPI({ commit }, idEmpresa) {
    try {
      const response = await empresaService.getEmpresaAPI(idEmpresa);
      // console.log('fetchEmpresaAPI', response);
      commit('SET_EMPRESA', response);
      commit('SET_IS_EMPRESAS_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchEmpresasAPI({ commit }) {
    try {
      const response = await empresaService.getEmpresasAPI();
      commit('SET_EMPRESAS', response);
      commit('SET_IS_EMPRESAS_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
};

const mutations = {
  CLEAR_EMPRESAS_STATE: state => Object.assign(state, getDefaultState()),
  SET_EMPRESAS: (state, empresas) => state.empresas = empresas,
  SET_EMPRESA: (state, empresa) => {
    state.empresa = empresa;
    state.empresas.push(empresa);
  },
  SET_IS_EMPRESAS_MODIFIED: (state, isModified) => state.isModified = isModified
};

export default {
  state,
  getters,
  actions,
  mutations
}